const ShopMetaSelectFragmentDoc = `
    fragment ShopMetaSelect on ShopMeta {
  id
  value
  key
  createdAt
  updatedAt
}
    `;

export const ShopMetaByKeyDocument = `
  query shopMetaByKey($key: String!) {
    shopMetaByKey(key: $key) {
      ...ShopMetaSelect
    }
  }
  ${ShopMetaSelectFragmentDoc}
`;

export const ShopMetaCreateOrUpdateDocument = `
    mutation shopMetaCreateOrUpdate($input: UpsertShopMetaInput!) {
  shopMetaCreateOrUpdate(input: $input) {
    createdAt
    id
    key
    updatedAt
    value
  }
}
    `;
